import React from 'react';
import { Typography } from 'antd';

type StarterTrialActivationChoiceProps = {
  planName: string;
  // When false, the user reached this from the Overview "Activate now" CTA (they've already added
  // payment / gone through the after-trial flow), so only the "Activate now" explanation is shown
  // and the "after trial" option is dropped (PRE-2726 QA).
  showAfterTrial?: boolean;
};

// Explains the paid-activation choice(s) for a Starter trial user. The action buttons themselves
// live in the modal's confirmation footer (under Price, next to Cancel) — not here — so they sit
// below the payment method / billing address sections (PRE-2726 QA).
function StarterTrialActivationChoice({ planName, showAfterTrial = true }: StarterTrialActivationChoiceProps) {
  return (
    <>
      <Typography.Paragraph>
        <Typography.Text strong>Activate now</Typography.Text> ends your trial and starts billing immediately — your
        billing cycle starts today and your render counter resets to zero.
      </Typography.Paragraph>
      {showAfterTrial && (
        <Typography.Paragraph>
          <Typography.Text strong>Activate after trial</Typography.Text> keeps your trial running and starts paid{' '}
          {planName} automatically when the trial ends.
        </Typography.Paragraph>
      )}
    </>
  );
}

export default StarterTrialActivationChoice;
